import {PHPErrorResponse, PHPResponse} from '@/api/channel/type';

export const SETTING_BASIC_ERROR = {
  NOT_ALLOW_STATION_NAME: 1305, // 사용할 수 없는 방송국 이름입니다.
  NONE_STATION_NAME: 1305, // 방송국 이름을 입력해 주세요.
  LONG_STATION_NAME: 1306, // 한글 6자, 영문 12자 이하로 입력해 주세요.
  OVERLAP_STATION_NAME: 1307, // 이미 사용중인 방송국 이름 입니다.
} as const;

export type SettingBasicError =
  (typeof SETTING_BASIC_ERROR)[keyof typeof SETTING_BASIC_ERROR];

export const SETTING_BASIC_ERROR_LIST = Object.values(SETTING_BASIC_ERROR);

export interface StationNameParamsSchema {
  userId: string;
  stationName: string;
  mode: 'check' | 'UPDATE'; // 진짜 이렇게 대소문자가 다름
  _token: ''; // 진짜 항상 빈값임
  _method: 'put'; // TODO: 다른 method 사용하는 경우 있는지 확인 필요
}

export interface StationNameResponseSchema
  extends PHPResponse<{
    stationName: string;
  }> {}

export interface StationNameErrorResponse
  extends PHPErrorResponse<SettingBasicError> {}

export interface NickNameParamsSchema {
  szWork: 'check' | 'update';
  szNick: string;
}

export interface NickNameResponseSchema {
  message: string; // 실제로 대문자인데 axios 에서 변환시켜줌
  result: number; // 실제로 대문자인데 axios 에서 변환시켜줌
  nickname?: string; // 실제로 대문자인데 axios 에서 변환시켜줌
}

export interface ProfileTextParamsSchema {
  userId: string;
  profileText: string;
}

export interface AIProfileConfYnParamsSchema {
  userId: string;
  aiflag: 'Y' | 'A';
}

export interface AIProfileConfYnResponseSchema {
  message: string;
  aiflag: 'Y' | 'A';
}

export interface ProfileTextResponseSchema {
  message: string;
  profileText: string;
}

export interface OuterLinkParamsSchema {
  userId: string;
}

export const OUTER_LINK_TYPE = {
  FACEBOOK: 1,
  INSTAGRAM: 2,
  YOUTUBE: 3,
  NAVER: 4,
  SOOP: 5,
  ETC: 9,
  NONE: 0,
} as const;

export interface OuterLinkResponseSchema {
  csrcToken: null; // 추후 이게 뭔지 파악
  data: OuterLinkSchema[];
}

export type OuterLinkType =
  (typeof OUTER_LINK_TYPE)[keyof typeof OUTER_LINK_TYPE];

export interface OuterLinkSchema {
  no: number;
  userId: string;
  type: OuterLinkType;
  linkName: string;
  url: string;
  image: null;
  regDate: string; // yyyy-mm-dd hh:mm:ss
}

export interface PutOuterLinkSchema {
  linkName: string;
  no: string;
  type: string;
  url: string;
}

export interface PutOuterLinkParamsSchema {
  userId: string;
  linkList: PutOuterLinkSchema[];
}

export interface PutOuterLinkResponseSchema {
  message: string;
  result: number;
}

export interface TitleImageParamsSchema {
  userId: string;
  data: FormData;
}

export interface TitleImageResponseSchema {
  uploaded: number;
  fid: number;
  key: string;
  size: number;
  width: number;
  height: number;
  filename: string;
  domain: string;
  url: string;
  rnum: number;
  originalName: string;
}

export interface CropTitleImageParamsSchema {
  userId: string;
  data: FormData;
}

export interface CropTitleImageResponseSchema {
  pc: CropTitleImagePcSchema;
  palettes: string[];
}

export interface CropTitleImagePcSchema {
  uploaded: number;
  fid: number;
  key: string;
  size: number;
  width: number;
  height: number;
  filename: string;
  domain: string;
  url: string;
  rnum: number;
  originalName: string;
}

export interface SaveTitleImageParamsSchema {
  userId: string;
  data: FormData;
}

interface TitleImageSchema {
  stationNo: number;
  pcUrl: string;
  isInit: boolean;
  palettes: string[];
}

export interface SaveTitleImageResponseSchema extends TitleImageSchema {}

export interface GetTitleImageParamsSchema {
  userId: string;
}

export interface GetTitleImageResponseSchema extends TitleImageSchema {}

export interface ResetTitleImageParamsSchema {
  userId: string;
  data?: FormData;
}

export interface ResetTitleImageResponseSchema extends TitleImageSchema {}

export interface PostProfileImageParamsSchema {
  userId: string;
  data: FormData;
}

export interface PostProfileImageResponseSchema {
  data: {
    profileImage: string;
  };
}

export interface ResetProfileImageParamsSchema {
  userId: string;
  data?: FormData;
}

export interface ResetProfileImageResponseSchema {
  data: {
    profileImage: string;
  };
}

export interface GetBannerListResponseSchema {
  data: BannerSchema[];
  csrfToken: null;
}

export const BANNER_TYPE = {
  FLOATING: 1,
  PC_BOTTOM: 2,
  MOBILE_BOTTOM: 3,
} as const;

export type BannerType = (typeof BANNER_TYPE)[keyof typeof BANNER_TYPE];

export interface BannerSchema {
  bannerIdx: number;
  stationNo: number;
  userId: string;
  bannerType: BannerType;
  fileName: string;
  linkUrl: string;
  viewYn: number;
  regDate: string;
  mode: string;
}

export interface UploadBannerImageParamsSchema {
  userId: string;
  data: FormData;
}

export interface UploadBannerImageResponseSchema {
  data: BannerSchema;
}

export interface SaveBannerParamsSchema {
  userId: string;
  data: FormData;
}

export interface SaveBannerResponseSchema {
  data: BannerSchema;
}

export interface UpdateBannerParamsSchema {
  userId: string;
  id: number;
  data: FormData;
}

export interface UpdateBannerResponseSchema {
  data: BannerSchema;
}

export interface DeleteBannerParamsSchema {
  userId: string;
  id: number;
  type: BannerType;
}

export interface DeleteBannerResponseSchema {
  data: {
    bannerIdx: number;
  };
}
